// 性别
export const genderList = [
  {
    text: '男',
    value: 1,
  },
  {
    text: '女',
    value: 2,
  },
]

// 政治面貌
export const politicalOutlook = [
  {
    text: '党员',
    value: 1,
  },
  {
    text: '群众',
    value: 2,
  },
  {
    text: '其他',
    value: 0,
  },
]

// 舞蹈总类
export const danceList = [
  {
    text: 'BREAKING',
    value: 'BREAKING',
  },
  {
    text: 'POPPING',
    value: 'POPPING',
  },
  {
    text: 'HIPHOP',
    value: 'HIPHOP',
  },
  {
    text: 'LOCKING',
    value: 'LOCKING',
  },
  {
    text: 'JAZZ',
    value: 'JAZZ',
  },
  {
    text: 'URBAN',
    value: 'URBAN',
  },
  {
    text: 'HOUSE',
    value: 'HOUSE',
  },
  {
    text: 'WAACKING',
    value: 'WAACKING',
  },
  {
    text: '其他',
    value: '其他',
  },
]

// 会员
export const memberList = [
  {
    text: '学生会员',
    value: 1,
  },
  {
    text: '会员',
    value: 2,
  },
  {
    text: '荣誉会员',
    value: 3,
  },
]

// 申请级别
export const levelList = [
  {
    text: '会员单位',
    value: 1,
  },
  {
    text: '五星会员',
    value: 2,
  },
  {
    text: '副主任会员',
    value: 3,
  },
  {
    text: '主任会员',
    value: 4,
  },
]
// 有无
export const yesNolList = [
  {
    text: '有',
    value: 1,
  },
  {
    text: '无',
    value: 0,
  },
]

// 所属委员会
export const committeeType = [
  {
    text: '竞赛委员会',
    value: 1,
  },
  {
    text: '裁判委员会',
    value: 2,
  },
  {
    text: '技术标准委员会',
    value: 3,
  },
  {
    text: '推广普及委员会',
    value: 4,
  },
  {
    text: '行业发展中心',
    value: 5,
  },
  {
    text: '省队',
    value: 6,
  },
  {
    text: '顾问团',
    value: 7,
  },
]

// 申请协会职位
export const societyPosition = [
  {
    text: '主任',
    value: 1,
  },
  {
    text: '副主任',
    value: 2,
  },
  {
    text: '委员',
    value: 3,
  },
  {
    text: '省队教练组',
    value: 4,
  },
]